/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type CreateDepositRequestAssetSymbol = typeof CreateDepositRequestAssetSymbol[keyof typeof CreateDepositRequestAssetSymbol];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateDepositRequestAssetSymbol = {
  HKD: 'HKD',
  JPY: 'JPY',
  USD: 'USD',
  GOLD: 'GOLD',
  CNH: 'CNH',
  THB: 'THB',
  SGD: 'SGD',
  CAD: 'CAD',
  GBP: 'GBP',
  EUR: 'EUR',
  RMB: 'RMB',
  CNY: 'CNY',
  AUD: 'AUD',
  BRL: 'BRL',
  NZD: 'NZD',
  PYG: 'PYG',
  TWD: 'TWD',
  AAVE: 'AAVE',
  ADA: 'ADA',
  BCH: 'BCH',
  BNB: 'BNB',
  BTC: 'BTC',
  BUSD: 'BUSD',
  COMP: 'COMP',
  DAI: 'DAI',
  DOGE: 'DOGE',
  DOT: 'DOT',
  ETH: 'ETH',
  FTT: 'FTT',
  GRT: 'GRT',
  HT: 'HT',
  LINK: 'LINK',
  LTC: 'LTC',
  MATIC: 'MATIC',
  PAX: 'PAX',
  SHIB: 'SHIB',
  SOL: 'SOL',
  SRM: 'SRM',
  TRX: 'TRX',
  TST: 'TST',
  TXAG: 'TXAG',
  TXAU: 'TXAU',
  TXPD: 'TXPD',
  TXPT: 'TXPT',
  USDC: 'USDC',
  USDT: 'USDT',
  XRP: 'XRP',
  YFI: 'YFI',
  AVAX: 'AVAX',
  ALGO: 'ALGO',
  APE: 'APE',
  AXS: 'AXS',
  CRO: 'CRO',
  ENJ: 'ENJ',
  FIL: 'FIL',
  FTM: 'FTM',
  LOOKS: 'LOOKS',
  LUNAC: 'LUNAC',
  MANA: 'MANA',
  ONE: 'ONE',
  PAXG: 'PAXG',
  RAY: 'RAY',
  SAND: 'SAND',
  SLC: 'SLC',
  SUSHI: 'SUSHI',
  UNI: 'UNI',
  USDP: 'USDP',
  USTC: 'USTC',
  INJ: 'INJ',
  BSV: 'BSV',
  XAU: 'XAU',
  XAG: 'XAG',
  XPT: 'XPT',
  XPD: 'XPD',
  Insurance: 'Insurance',
  Security: 'Security',
} as const;
